<template>
  <div class="cf-flex cf-flex--column">
    <div class="cf-flex cf-flex--column cf-flex--gap-16">
      <div
        v-if="!giftCards.areLoading && giftCards.savedCards.length === 0"
        class="cf-flex cf-flex--column cf-flex--justify-center cf-flex--gap-16 cf-text-align-center cf-padding-top-16"
      >
        <img
          class="cf-illustration cf-illustration--gift-card"
          alt="Gift Card"
          src="/images/illustrations/gift-card.svg"
        >

        <h2 class="cf-title cf-title--2">
          Add a Gift Card
        </h2>

        <p class="cf-subtitle cf-subtitle--2">
          It seems you don't have any gift cards. You can check the balance of an existing card or
          <span class="no-wrap">purchase one.</span>
        </p>
      </div>

      <div class="cf-flex cf-flex--column cf-flex--gap-16">
        <div
          v-if="giftCards.areLoading"
          class="cf-section-loader-container"
        >
          <div class="cf-loader" />
        </div>

        <div
          v-else-if="giftCards.savedCards.length > 0"
          class="cf-flex cf-flex--column cf-flex--gap-10"
        >
          <div
            v-for="card in giftCards.savedCards"
            :key="card.cardNumber"
            class="cf-card cf-card--clickable cf-grid cf-grid--2-grid-column-equal"
            @click="$openModal('giftCardDetails', { card })"
          >
            <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-10">
              <cf-card-type-icon
                payment-type="GiftCard"
                :card-design-url="card.design.url"
              />

              <h4 class="cf-title cf-title--4">
                •••• {{ card.cardNumberLastFour }}
              </h4>

              <span
                v-if="card.autoReload && card.autoReload.enabled"
                v-tippy="'Auto Reload Enabled'"
                class="cf-icon cf-icon--black fa-repeat"
              />
            </div>

            <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-end cf-flex--gap-8">
              <p class="cf-subtitle cf-subtitle--3 cf-subtitle--heavy">
                {{ $dollars(card.amount) }}
              </p>

              <button
                type="button"
                class="cf-button cf-button--tertiary cf-button--xs"
              >
                Edit
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="!giftCards.areLoading"
        class="cf-flex cf-flex--row cf-flex--justify-center"
      >
        <div class="cf-grid cf-grid--2-grid-column-equal cf-grid--gap-16 cf-mobile-column cf-max-width-600">
          <button
            type="button"
            class="cf-button cf-button--secondary cf-button--lg cf-button--auto"
            @click="$openModal('giftCardAdd')"
          >
            Add Card
          </button>

          <button
            type="button"
            class="cf-button cf-button--primary cf-button--lg cf-button--auto"
            @click="$openModal('giftCardPurchase')"
          >
            Purchase Card
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import errorHandlers from '@/services/error-handlers';

  import dollars from '@/filters/dollars';

  import CfCardTypeIcon from '@/view/components/shared/cf-card-type-icon/index.vue';


  export default {
    name: 'GiftCardsPage',

    components: {
      CfCardTypeIcon
    },

    metaInfo() {
      return {
        title: 'Gift Cards'
      };
    },

    computed: {
      ...mapGetters('giftCards', ['giftCards'])
    },

    created() {
      this.createdHandler();
    },

    methods: {
      dollars,

      async createdHandler() {
        try {
          await this.$store.dispatch('giftCards/getSavedCards');
        }
        catch (error) {
          errorHandlers.generic(error);
        }
      }
    }
  };
</script>
